import { useEffect, useCallback, useRef } from 'react';

const useInfiniteScroll = callback => {
    const ref = useRef(null);
    const page = useRef(1);

    const loadMore = useCallback(
        ([entry]) => {
            if (entry.isIntersecting) {
                page.current = page.current + 1;
                callback(page.current);
            }
        },
        [callback],
    );

    useEffect(() => {
        const refCurrent = ref.current;
        const observer = new IntersectionObserver(loadMore, {
            root: null,
            rootMargin: '0px',
            threshold: 0.25,
        });

        if (refCurrent) {
            observer.observe(refCurrent);
        }

        return () => {
            if (refCurrent) {
                observer.unobserve(refCurrent);
            }
        };
    }, [ref, loadMore]);

    return ref;
};

export default useInfiniteScroll;
